import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_MobileAdviserProfile.scss'
import { Row, Col } from 'react-bootstrap'
import Rating from '../../../common/Rating'
import IsIndependent from '../../../common/AdviserProfiles/IsIndependent/IsIndependent'
import PrimaryActionButton from '../../../common/Buttons/PrimaryActionButton'
import AdviserProfilePictures from '../../../common/AdviserProfiles/AdviserProfilePictures'
import AdviserProfileInvestmentMinimums from '../../../common/AdviserProfiles/AdviserProfileInvestmentMinimums'
import AdviserProfileEducation from '../../../common/AdviserProfiles/AdviserProfileEducation'
import AdviserProfileWorkExperience from '../../../common/AdviserProfiles/AdviserProfileWorkExperience'
import AdviserProfileAreasOfSpecialisation from '../../../common/AdviserProfiles/AdviserProfileAreasOfSpecialisation'
import AdviserProfileLanguagePreferences from '../../../common/AdviserProfiles/AdviserProfileLanguagePreferences'
import AdviserProfileBlurb from '../../../common/AdviserProfiles/AdviserProfileBlurb'
import AdviserProfileClientPreferences from '../../../common/AdviserProfiles/AdviserProfileClientPreferences'
import DistanceToAdviser from '../../../common/DistanceToAdviser'
import PropTypes from 'prop-types';

class MobileAdviserProfile extends React.Component {

  static propTypes = {
    profile: PropTypes.object,
    contactAdviser: PropTypes.func.isRequired,
    rateAdviser: PropTypes.func.isRequired,
    investorLocation: PropTypes.string
  };

  render () {
    const profile = this.props.profile

    return (
      <Row>
        <Col xs={12} className="d-block d-md-none">
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfilePictures profilePicture={profile.profilePic} companyLogo={profile.companyLogo} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfileBlurb profile={profile} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <Rating
                average={profile?.rating?.average || 0}
                totalReviews={profile?.rating?.totalReviews || 0}
                mobile />
              <a
                className={styles['rating-button']}
                onClick={this.props.rateAdviser}
                target='blank'>
                Rate this adviser
              </a>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <IsIndependent
                isIndependent={profile.isIndependent}
                className={styles['independence-mobile']}
                conflictDeclarations={profile.conflictDeclarations}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <PrimaryActionButton
                className={styles['full-width']}
                buttonText={'Contact adviser'}
                onClick={this.props.contactAdviser} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <DistanceToAdviser
                fromLocation={this.props.investorLocation}
                toLocation={`${profile.streetAddress}, ${profile.suburb}, ${profile.city}, South Africa`}
                distanceToAdviser={profile.distanceToAdviser}
                compact />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfileInvestmentMinimums investmentMinimums={profile.investmentMinimums} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfileEducation qualifications={profile.qualifications} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfileWorkExperience experiences={profile.workExperiences} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfileLanguagePreferences languages={profile.languagePreferences} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfileAreasOfSpecialisation areas={profile.financialServicesOffered} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfileClientPreferences clientPreferences={profile.clientTypePreferences} />
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

}

export default  (MobileAdviserProfile)
